import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94581c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "briefbox flex f-d j-s-e" }
const _hoisted_2 = { class: "title flex j-s-b a-c" }
const _hoisted_3 = { class: "profile flex j-s-b" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "头像:", -1))
const _hoisted_5 = { class: "flex a-s" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["accept", "multiple"]
const _hoisted_9 = { class: "name flex j-s-b" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "名称:", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "company flex j-s-b" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "tel flex j-s-b" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "联系电话:", -1))
const _hoisted_17 = { class: "person flex j-s-b" }
const _hoisted_18 = ["disabled"]

import { UserDetails } from "@/services/datatype/entity/user/UserDetails";
import UserTools from "@/services/session/UserTools";
import UserSuppliedEntityInfoUtils from "@/services/util/UserSuppliedEntityInfoUtils";
import {
  OSSCredentialProvider,
  OssTokenConsumer,
} from "@/services/util/oss/OSSCredentialProvider";
import { OSSFederationToken } from "@/services/util/oss/OSSFederationToken";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import CheckType from "@/utils/CheckType";
import OSS from "ali-oss";
import { ElMessage } from "element-plus";
import { onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { SupplierDetails } from "@/services/datatype/entity/enterprise/SupplierDetails";
import IssueUtils from "@/utils/IssueUtils";
import entiyinfo from "@/api/entiyinfo";

export default /*#__PURE__*/_defineComponent({
  __name: 'Brief',
  setup(__props) {

const route = useRoute();
const personState = ref<boolean>();
const modifyState = ref(true);
const accept = ref<string>("");
const changeLogo = () => {
  if (!modifyState.value) {
    accept.value = "image/*";
    setTimeout(() => {
      (document.getElementsByClassName("file")[0] as HTMLInputElement).click();
    }, 100);
  }
};
const userMessage = reactive({
  img: "",
  name: "",
  company: "",
  mobile: "",
  description: "",
  locationName: "",
  showImageUrls: [],
});
let all = reactive([]);
const upload = (e) => {
  const fileList = [];
  const fileTarget: any = e.target;
  const tokenConsumer: OssTokenConsumer = async (
    token: OSSFederationToken
  ): Promise<void> => {
    if (token) {
      const client = new OSS({
        region: "oss-cn-hangzhou",
        accessKeyId: token.tempAK,
        accessKeySecret: token.tempSK,
        stsToken: token.securityToken,
        bucket: "gong-wei",
      });
      for (const files of fileTarget.files) {
        fileList.push(files);
      }
      if (personState.value) {
        const fullFileName: string = IssueUtils.newFileName(token, fileList[0]);
        const result = await client.put(fullFileName, fileList[0]);
        userMessage.img = CheckType.isImg(IssueUtils.getResult(result));
      } else {
        // 律所用
        if (fileList.length > 4) {
          ElMessage.error("最多只能上传四张图片");
        } else {
          userMessage.showImageUrls &&
            userMessage.showImageUrls.splice(
              0,
              userMessage.showImageUrls.length
            );
          fileList.forEach(async (r, i) => {
            const fullFileName: string = IssueUtils.newFileName(
              token,
              fileList[0]
            );
            const result = await client.put(fullFileName, r);
            if (i == 0) {
              userMessage.img = CheckType.isImg(IssueUtils.getResult(result));
            } else {
              userMessage.showImageUrls.push(IssueUtils.getResult(result));
            }
          });
        }
      }
      (document.getElementsByClassName("file")[0] as HTMLInputElement).value =
        null;
    }
  };
  OSSCredentialProvider.getInstance().getFederationToken(tokenConsumer);
};
const getData = () => {
  all.splice(0, all.length);
  if (personState.value) {
    entiyinfo.getPersonBriefData(UserTools.getUserId(), 0, true).then((t) => {
      all.push(t.data);
      userMessage.name = t.data.entityDesc.nickName;
      userMessage.img = t.data.entityDesc.imageUrl
        ? CheckType.isImg(t.data.entityDesc.imageUrl)
        : require("../../assets/images/entiyInfo/logo.png");
      userMessage.description = t.data.entityDesc.description;
      console.log(t.data.entityDesc.additionalAttributes);
      userMessage.mobile = (
        t.data.entityDesc.additionalAttributes as UserDetails
      ).mobile
        ? (t.data.entityDesc.additionalAttributes as UserDetails).mobile +
          "(不可修改)"
        : "暂无手机号" + "(不可修改)";
      userMessage.company = (
        t.data.entityDesc.additionalAttributes as UserDetails
      ).workerInfo.enterpriseInfo.entityName;
    });
  } else {
    // 给律所用
    const targetEntityId = (
      UserTools.getLoginSystemSuppliedEntityInfo().entityDesc
        .additionalAttributes as UserDetails
    ).workerInfo.enterpriseInfo.entityId;
    entiyinfo.getPersonBriefData(targetEntityId, 0, true).then((t) => {
      console.log(t);
      all.push(t.data);
      userMessage.name = t.data.entityDesc.nickName;
      userMessage.img = t.data.entityDesc.imageUrl
        ? CheckType.isImg(t.data.entityDesc.imageUrl)
        : require("../../assets/images/entiyInfo/logo.png");
      userMessage.locationName = t.data.entityDesc.locationName;
      userMessage.showImageUrls = t.data.entityDesc.showImageUrls;
      userMessage.mobile = (
        t.data.entityDesc.additionalAttributes as SupplierDetails
      ).telPhone
        ? (t.data.entityDesc.additionalAttributes as SupplierDetails).telPhone +
          "(不可修改)"
        : "暂无手机号" + "(不可修改)";
      userMessage.description = t.data.entityDesc.description;
    });
  }
};
const submit = () => {
  if (modifyState.value) {
    modifyState.value = false;
  } else {
    if (personState.value) {
      all[0].entityDesc.nickName = userMessage.name;
      all[0].entityDesc.imageUrl = userMessage.img
        .split("/")
        .splice(3, userMessage.img.split("/").length)
        .join("/");
      all[0].entityDesc.description = userMessage.description;
      (
        all[0].entityDesc.additionalAttributes as UserDetails
      ).workerInfo.enterpriseInfo.entityName = userMessage.company;
      DefaultWebServiceFactory.getInstance()
        .getWebEntityService()
        .updateEntity(
          UserSuppliedEntityInfoUtils.createUserSuppliedEntityInfo(all[0])
        )
        .then((t) => {
          // console.log(t);
          if (t) {
            ElMessage({
              message: "修改成功",
              type: "success",
            });
            getData();
            modifyState.value = true;
          }
        });
    } else {
      // 给律所用
      all[0].entityDesc.nickName = userMessage.name;
      all[0].entityDesc.imageUrl = userMessage.img
        .split("/")
        .splice(3, userMessage.img.split("/").length)
        .join("/");
      all[0].entityDesc.description = userMessage.description;
      all[0].entityDesc.locationName = userMessage.locationName;
      all[0].entityDesc.showImageUrls = userMessage.showImageUrls;
      DefaultWebServiceFactory.getInstance()
        .getWebEntityService()
        .updateEntity(
          UserSuppliedEntityInfoUtils.createUserSuppliedEntityInfo(all[0])
        )
        .then((t) => {
          if (t) {
            ElMessage({
              message: "修改成功",
              type: "success",
            });
            getData();
            modifyState.value = true;
          }
        });
    }
  }
};
onMounted(() => {
  personState.value = route.name == "entiyInfo" ? true : false;
  getData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(personState.value ? "您的个人资料详细信息" : "律所资料详细信息") + ":", 1),
      _createVNode(_component_el_button, { onClick: submit }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(modifyState.value ? "修改" : "确认"), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          onClick: changeLogo,
          src: userMessage.img,
          alt: ""
        }, null, 8, _hoisted_6),
        (!personState.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "最多添加4张，其中第一张为头像，其余为轮播图"))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          hidden: "",
          class: "file",
          onChange: _cache[0] || (_cache[0] = (e) => upload(e)),
          accept: accept.value,
          multiple: personState.value ? false : true
        }, null, 40, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("textarea", {
        class: "input-name",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userMessage.name) = $event)),
        disabled: modifyState.value
      }, null, 8, _hoisted_11), [
        [_vModelText, userMessage.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("h1", null, _toDisplayString(personState.value ? "所属公司" : "地址") + ":", 1),
      (personState.value)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            class: "input-company j-s-b",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userMessage.company) = $event)),
            disabled: modifyState.value
          }, null, 8, _hoisted_13)), [
            [_vModelText, userMessage.company]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 1,
            class: "input-company j-s-b",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userMessage.locationName) = $event)),
            disabled: modifyState.value
          }, null, 8, _hoisted_14)), [
            [_vModelText, userMessage.locationName]
          ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _withDirectives(_createElementVNode("textarea", {
        class: "input-tel",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userMessage.mobile) = $event)),
        disabled: true
      }, null, 512), [
        [_vModelText, userMessage.mobile]
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("h1", null, _toDisplayString(personState.value ? "个人简介" : "律所简介") + ":", 1),
      _withDirectives(_createElementVNode("textarea", {
        class: "input-person",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userMessage.description) = $event)),
        disabled: modifyState.value
      }, null, 8, _hoisted_18), [
        [_vModelText, userMessage.description]
      ])
    ])
  ]))
}
}

})